enum ControlsStatus {
    ACTIVE = 'ACTIVE',
    IDLE = 'IDLE'
}

export default ControlsStatus;